import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { ToastService } from 'src/app/base/services/toast.service';
import { homeRoute } from './../../core/routing/route-names';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { UserInfoDTO, UpdateUserInfoDTO, UserAccountClient } from './../models/models.swagger.generated';
import { AuthService } from './../services/auth.service';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserEditFormComponent } from '../user-edit-form/user-edit-form.component';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    imports: [UserEditFormComponent, TranslateModule]
})
export class EditProfileComponent {

  public userInfo: UserInfoDTO = this.authService.getUserInfo();
  public userEditForm = this.fb.group({
    userId: this.userInfo.userId,
    firstname: [this.userInfo.firstname, [Validators.required]],
    lastname: [this.userInfo.lastname, [Validators.required]],
    language: [this.userInfo.language, [Validators.required]],
    email: [this.userInfo.email, [Validators.required, Validators.email]],
    phoneNumber: [this.userInfo.phoneNumber, [CustomValidatorsFactory.createPhoneValidator()]],
    enabled: [this.userInfo.enabled],
    role: [this.userInfo.roles[0]],
    clientId: this.userInfo.clientId
  });

  constructor(private authService: AuthService,
              private userAccountClient: UserAccountClient,
              private toastService: ToastService,
              private router: Router,
              private fb: UntypedFormBuilder) {
  }

  public save(): void {
    if (this.userEditForm.valid) {
      this.userAccountClient.updateUser(this.mapToUpdateUserInfoDTO(this.userEditForm.value))
        .subscribe({ next: res => {
          this.authService.loadUserInfoDTO();
          this.router.navigate([homeRoute]);
        }, error: error => {
          this.toastService.showApiException(error,
            'i18n.core.messages.user-edit.title',
            'i18n.core.messages.user-edit.message');
        }});
    }

  }

  private mapToUpdateUserInfoDTO(formData: any): UpdateUserInfoDTO {
    const dto = new UpdateUserInfoDTO();
    dto.userId = formData.userId;
    dto.clientId = formData.clientId;
    dto.email = formData.email;
    dto.enabled = formData.enabled;
    dto.firstname = formData.firstname;
    dto.lastname = formData.lastname;
    dto.language = formData.language;
    dto.phoneNumber = formData.phoneNumber;
    dto.roles = [formData.role];

    return dto;
  }

}
